<template>
  <EntityList
    :config="config"
    :columns="columns"
    :form-fields="formFields"
    authority="General_Cover_Area"
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'

import storeModule from '../storeModule'

export default {
  components: {
    EntityList,
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'cover-areas',
        endpoint: 'cover-areas',
        route: 'cover-areas',
        title: {
          single: this.$i18n.t('State'),
          plural: this.$i18n.t('States'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'eshopCode', label: this.$t('code'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'lat', label: this.$t('Lat'), sortable: false },
        { key: 'lng', label: this.$t('Lng'), sortable: false },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formFields() {
      return [
        {
          id: 'eshopCode',
          type: 'text',
          label: this.$t('code'),
          required: true,
          rules: 'max:10',
        },
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: true,
          rules: 'max:40',
        },
        {
          id: 'lat',
          type: 'text',
          label: this.$t('Lat'),
          rules: 'positive',
          required: false,
        },
        {
          id: 'lng',
          type: 'text',
          label: this.$t('Lng'),
          rules: 'positive',
          required: false,
        },
        {
          id: 'radius',
          type: 'number',
          label: this.$t('radius'),
          required: false,
        },
        {
          id: 'enabled',
          type: 'checkbox',
          label: this.$t('enabled'),
          initVal: 1,
        },
      ]
    },
  },
}
</script>
